export const orange = '#d2a44f';
export const black = '#000';
export const white = '#fff';
export const darkTreeGreen = '#0d1a17';
